import '../globals';

;(function ($, _, document, globalUrls, globalTranslations) {
    'use strict';

    var pluginName = 'dropdownHover';

    function Plugin(element) {
        this.element = $(element);
        this._name = pluginName;
        this.init();

        return this;
    }

    $.extend(Plugin.prototype, {
        hoverIn: function () {
            const elementToBeShown = $(this).find('.dropdown-menu').first();
            $('.dropdown-hover').children('.dropdown-menu')
                .not('.shopping-button-dropup')
                .not(elementToBeShown).stop(true, true).hide();

            if (!elementToBeShown.is(":visible")) {
                $(this).trigger('show.bs.dropdown');
            }

            elementToBeShown.stop(true, true).delay(100).show(0);
        },

        hoverOut: function () {
            $(this).children('.dropdown-menu').stop(true, true).delay(500).hide(0);
        },

        subMenuHoverIn: function () {
            $(this).stop(true, true);
        },

        subMenuHoverOut: function () {
            $(this).stop(true, true).delay(500).hide(0);
        },

        create: function () {
            const that = this;

            that.element.unbind('mouseenter', that.hoverIn);
            that.element.unbind('mouseleave', that.hoverOut);

            that.element.find('.dropdown-menu').unbind('mouseenter', that.subMenuHoverIn);
            that.element.find('.dropdown-menu').unbind('mouseleave', that.subMenuHoverOut);

            that.element.find('.dropdown-menu').removeAttr('style');

            if (window.checkViewport('min-width: 768px')) {
                that.element.hover(
                    that.hoverIn,
                    that.hoverOut
                );

                that.element.children('.dropdown-menu').hover(
                    that.subMenuHoverIn,
                    that.subMenuHoverOut
                );
            }
        },
        init: function () {
            var that = this;
            that.create();

            $(window).smartresize(function () {
                that.create();
            });
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function () {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this));
            }
        });
    };
})
(jQuery, _, document, globalUrls, globalTranslations);
